import { Component, Prop } from 'vue-property-decorator';
import ClButtonBase from '../ClButtonBase';
import { ClButtonProps } from '../ClButton';

@Component({
  components: {
    ClButtonBase
  }
})
export default class ClButton extends ClButtonBase implements ClButtonProps {
  /**
   * The color of the component
   */
  @Prop({
    type: String as () => ClButtonProps['color'],
    default: 'default',
    validator: x =>
      [
        'default',
        'inherit',
        'primary',
        'secondary',
        'warning',
        'error',
        'success'
      ].includes(x)
  })
  public color!: ClButtonProps['color'];

  /**
   * If true, the component will take up the entire available width of it's parent element.
   */
  @Prop({
    default: false,
    type: Boolean
  })
  public fullWidth!: boolean;

  /**
   * If variant is fab and mini is true, the fab button will be the mini version.
   */
  @Prop({
    default: false,
    type: Boolean
  })
  public mini!: boolean;

  /**
   * The size of the component
   */
  @Prop({
    default: 'primary',
    type: String as () => ClButtonProps['size'],
    validator: x =>
      [
        'small', // deprecated
        'default', // deprecated
        'large', // deprecated
        'compact',
        'medium',
        'primary'
      ].includes(x)
  })
  public size!: ClButtonProps['size'];

  /**
   * If true, the component will not have a border radius
   */
  @Prop({
    default: false,
    type: Boolean
  })
  public square!: boolean;

  /**
   * Used to control the button's purpose.
   * This property passes the value to the type attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  @Prop({
    type: String,
    default: 'button',
    validator: x => ['button', 'submit', 'reset'].includes(x)
  })
  public type!: string;

  /**
   * The variant of the component
   */
  @Prop({
    default: 'text',
    type: String as () => ClButtonProps['variant'],
    validator: x =>
      ['text', 'contained', 'outlined', 'fab', 'extendedFab'].includes(x)
  })
  public variant!: ClButtonProps['variant'];

  get isMiniFab(): boolean {
    return (
      (this.variant === 'fab' || this.variant === 'extendedFab') && this.mini
    );
  }
}
